import React from 'react';
import { Link } from 'react-router-dom';
interface ButtonProps {
  children: React.ReactNode;
  href?: string;
  variant?: 'primary' | 'secondary';
  type?: 'button' | 'submit' | 'reset';
  className?: string;
  onClick?: () => void;
  target?: string;
  rel?: string;
}
const Button = ({
  children,
  href,
  variant = 'primary',
  type = 'button',
  className = '',
  onClick,
  target,
  rel
}: ButtonProps) => {
  const baseStyles = 'inline-flex items-center justify-center font-poppins font-medium text-sm uppercase tracking-wider rounded-lg transition-all duration-300';
  const variantStyles = {
    primary: 'bg-primary text-secondary hover:bg-primary/90 hover:shadow-gold-glow',
    secondary: 'bg-transparent border border-primary text-primary hover:bg-primary/5'
  };
  const styles = `${baseStyles} ${variantStyles[variant]} ${className}`;
  if (href) {
    // External link
    if (href.startsWith('http')) {
      return <a href={href} className={styles} target={target} rel={rel} data-id="element-113">
          {children}
        </a>;
    }
    // Internal link
    return <Link to={href} className={styles} data-id="element-114">
        {children}
      </Link>;
  }
  // Button
  return <button type={type} className={styles} onClick={onClick} data-id="element-115">
      {children}
    </button>;
};
export default Button;